import React, { useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography,Container,Button, Divider} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme,styled } from '@mui/material/styles'
import { ArrowDropDownCircleOutlined, Remove, RemoveCircle} from '@mui/icons-material';
import ContentView from './ContentView';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import ReactPlayer from 'react-player'


const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black"
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	height:120,
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	background:theme.palette.mode === 'dark'? 'black' : 'white',
}));

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
  minHeight:100,
  maxHeight:250,
  padding:5,
  justifyContent:"center",
  alignItems:"center",
  borderRadius: 5
}),

);


const SectionsDialog = ({visible,setVisible,title,data,setData})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch()
	const [expanded, setExpanded] = useState(true);

	const handleChange = () => (event, newExpanded) => {
		setExpanded(newExpanded ? true : false);
	};

	const onOpen = () => {
		setVisible(true);
	};
	const onClose = () => {
		setVisible(false);
	};


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<MenuIcon/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Sections
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{minWidth:{xs:300,md:500},justifyContent:"center",background:theme.palette.background.default}}>
			 {
				data?.length == 0 && (
					<Box>
						<Typography m={1} style={{fontSize:15,fontWeight:400,color:"gold"}}>
							You do not have any sections
						</Typography>
					</Box>
				)
			 }
            {data?.map((item,index)=>{
                return(
                    <Box mb={3}  key={index}>
                    <Accordion key={index} sx={{width:{xs:"100%",md:"95%"},marginLeft:1}} expanded={expanded} onChange={handleChange(true)}>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                            <Box sx={{width:"100%"}}>
                                <Box sx={{textAlign:"left"}}>
									<IconButton onClick={(e)=>{
										e.preventDefault()
										setData(data?.filter(itm=>itm?.title !== item?.title))
									}}>
										<RemoveCircle fontSize='small' sx={{color:"red"}}/>
									</IconButton>
									<Typography style={{fontSize:13,fontFamily:"dinofans",color:"#fff"}}>
										{index+1}.  {item?.title}
									</Typography>
									
								</Box>
								<ContentView title="Description" content={item?.description}/>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails sx={{justifyContent:"center",alignItems:"center",ml:1}}>
							<Box display="flex" flexDirection="row" flexWrap="wrap">
								<ContentView titleSize={12} title="Language" content={item?.language}/>
								<ContentView titleSize={12} title="Level" content={item?.level}/>
								<ContentView titleSize={12} title="Duration" content={`${item?.duration} min`}/>
							</Box>
							<Box textAlign="left" width="100%">
								<Typography mt={1} mb={1} sx={{fontSize:14,fontFamily:"dinofans",color:"gold"}}>
									Questions
								</Typography>	
								<Divider/>							
							</Box>
							<ContainerBox mt={2}>
								{
									item?.questions?.map((itm,index)=>(
										<Box key={index} justifyContent="flex-start" alignItems="flex-start" width="100%">
											<ContentView titleSize={12} title={`#${index+1} Question`} content={itm?.question}/>
											{
												itm?.hasImage && (
													<img resizemode="cover" src={itm?.imageUrl} width={100} height={100} style={{borderRadius:5}}/>
												)
											}
											{
												itm?.hasAudio && (
													<audio
														src={itm?.audioUrl}
														controls
														style={{width:250,height:50}}
													/>
												)
											}
											{
												itm?.hasVideo && (
													<ReactPlayer url={itm?.videoUrl} width={250} height={120} controls style={{borderRadius:5,margin:10,marginLeft:40}}/>
												)
											}
											<ContentView titleSize={12} title="Question type" content={itm?.question_type}/>
											<ContainerBox sx={{width:"97%"}}>
												{
													itm?.responses?.map((it,index)=>(
														<ContentView titleSize={12} key={index} title={`# Possible response `} content={it}/>
													))
												}												
											</ContainerBox>
											<Divider sx={{mb:1}}/>
										</Box>
									))
								}
							</ContainerBox>
                        </AccordionDetails>
                    </Accordion>
                    </Box>
                )
            })}
		</DialogContent>
	</Dialog>
	)
}

export default SectionsDialog;